import { useMutation, useQueryClient } from "react-query";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";

export type UnlinkTagSetpointContextType = {
    setpointID: number;
    tagID: number;
}


export type UnlinkTagSetpointReturnType = {
    setpointID: number;
    count: number
};


export type UnlinkTagSetpointParameters = {
    groupID: number,
} & BaseUseMutationParameters<UnlinkTagSetpointReturnType, UnlinkTagSetpointContextType>;

export function useUnlinkTagSetpoint({
    groupID,
    onError,
    onSuccess
}: UnlinkTagSetpointParameters) {
    const queryClient = useQueryClient();

    return useMutation<UnlinkTagSetpointReturnType, RestError, UnlinkTagSetpointContextType>(
        async (o) => {
            const count = await AlarmSetpointsDataService.deleteTagSetPoint(
                groupID,
                o.tagID,
                o.setpointID,
            );

            return {
                setpointID: o.setpointID,
                count: count
            };
        },
        {
            onMutate: async () => {

                await queryClient.cancelQueries(keys.lists());

                return;
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _item, context) => {
                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
